/**
 * Where to send the user after a successful employee login.
 * Product default: User Management (`/users`). Uses `router.replace` so the login step
 * is not kept in browser history (back button should not return to the login form).
 *
 * @param _employee — optional; reserved for future role-based landing if needed
 */
export function getPostLoginRedirectPath(_employee?: {
  role?: string;
  designation?: string;
}): string {
  return '/users';
}
